import Vue from 'vue'

// css
import '../../node_modules/uikit/dist/css/uikit.min.css'
import '../sass/index.scss'

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

UIkit.use(Icons);

Vue.config.productionTip = false

import mixin from '../utils/mixin'

import AppOrderList from '../components/AppOrderList.vue';

new Vue({
  el: '#app',
  mixins: [mixin],
  components: { AppOrderList },
  data() {
    return {
      
    }
  },
  created() {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
  }
})
